import React, { useEffect } from 'react';
import { socketService } from '@services/SocketService';

interface SocketProviderProps {
  children: React.ReactNode;
}

export const SocketProvider: React.FC<SocketProviderProps> = ({ children }) => {
  useEffect(() => {
    // Don't connect automatically - wait for room creation/joining
    // This is because Cloudflare Workers requires a room-specific WebSocket URL
    
    // Disconnect only when app unmounts completely
    return () => {
      socketService.disconnect();
    };
  }, []);
  
  return <>{children}</>;
};